import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_V_L, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
import './Component_AdvisorWizard_Step_FreeText.scss';
import { currentTimeMillis } from '@nu-art/ts-common';
import { ModuleFE_Advisor_AdvisorSnippet } from '@app/advisor-frontend';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
import { FadeScrollWrapper } from '@app/styles';
import { displayMode_FreeText, stepStatus_NotSubmitted } from '@app/advisor-shared';
export class Component_AdvisorWizard_Step_FreeText extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.wizardData = nextProps.wizardData;
        state.stepIndex = nextProps.stepIndex;
        state.editableFreeText = state.wizardData.editProp('freeTextData', {});
        return state;
    }
    componentDidMount() {
        //Trigger an update in the scroll ref when this component mounts
        ModuleFE_ScrollBar.updateScrollBar(this.props.editorRef);
    }
    //######################### Logic #########################
    getSnippetsToRender = () => {
        const stepData = this.state.wizardData.item.stepData?.[this.state.stepIndex];
        return stepData?.snippets[displayMode_FreeText] ?? [];
    };
    isDisabled = () => this.state.wizardData.item.stepData?.[this.state.stepIndex].status !== stepStatus_NotSubmitted;
    //######################### Render #########################
    render() {
        const snippetIds = this.getSnippetsToRender();
        return _jsx(FadeScrollWrapper, { scrollRef: this.props.scrollRef, className: 'advisor-step__free-text-v2', children: snippetIds.map((id, index) => {
                return this.renderSnippet(id, snippetIds.length === 1);
            }) });
    }
    renderSnippet = (snippet, single) => {
        const dbSnippet = ModuleFE_Advisor_AdvisorSnippet.cache.unique(snippet.snippetId);
        if (!dbSnippet) {
            this.logError(`Could not find snippet for id ${snippet.snippetId}`);
            return;
        }
        const editable = this.state.editableFreeText;
        const disabled = this.isDisabled();
        const className = _className('advisor-step__free-text-v2__section', single && 'grow');
        return _jsxs(LL_V_L, { className: className, children: [!single && _jsx("div", { className: 'advisor-step__free-text-v2__section__title', children: dbSnippet.renderedLabel ?? dbSnippet.label }), _jsx(TS_TextArea, { type: 'text', resizeWithText: true, placeholder: disabled ? undefined : 'Type here', disabled: disabled, value: editable.item[snippet.snippetId]?.text, onChange: value => editable.updateObj({
                        [snippet.snippetId]: {
                            text: value,
                            hasChanges: true,
                            updateTimestamp: currentTimeMillis(),
                            resolvedVariableId: snippet.resolvedVariableId
                        }
                    }) })] }, snippet.snippetId);
    };
}
//# sourceMappingURL=Component_AdvisorWizard_Step_FreeText.js.map